<template>
  <v-select
    label="Select a payment method."
    :items="userIntegrations"
    item-text="name"
    item-value="id"
    no-data-text="You have no saved payment methods."
    prepend-icon="mdi-credit-card-outline"
    @input="$emit('input', $event)"
    :rules="[(v) => !!v]"
    :menu-props="{
      maxHeight: 'auto',
      top: true,
      offsetY: true,
      overflowY: true,
      nudgeLeft: 15
    }"
  >
    <template v-slot:append-item>
      <v-divider class="mb-2"></v-divider>
      <v-list-item>
        <v-list-item-content>
          <v-dialog
            v-model="addCard"
            :fullscreen="$vuetify.breakpoint.mobile"
            :transition="$vuetify.breakpoint.mobile ? 'dialog-bottom-transition' : '' "
            max-width="450px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  small
                  @click="addCard = true"
                  >
                  <v-icon class="mr-3">
                    mdi-credit-card-plus-outline
                  </v-icon>
                Add a New Card
              </v-btn>
            </template>
            <StripeIntegration v-on:close-card-form="addCard = false"></StripeIntegration>
          </v-dialog>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import StripeIntegration from './StripeIntegration.vue'

  export default {
    name: 'IntegrationSelect',

    components: {
      StripeIntegration
    },

    props: [
      'value'
    ],

    computed: {
      ...mapGetters([
        'userIntegration',
        'userIntegrations'
      ])
    },

    data: () => ({
      addCard: false
    }),

    methods: {
      ...mapActions([
        'getUserIntegrations'
      ]),
    },

    created() {
      this.getUserIntegrations()
    }
  }
</script>
